// utils/aoConnection.js
// AO connection configuration extracted from Profile.js

import { connect } from "@permaweb/aoconnect";
import { AOProcess } from "@ar.io/sdk/web";
import { CUSTOM_AO_CONFIG, CUSTOM_PROCESS_CONFIG } from './constants';

// Custom AO with correct mainnet URLs
export const customAo = connect({
  MODE: "legacy",
  CU_URL: CUSTOM_AO_CONFIG.CU_URL,
});

export const customProcess = new AOProcess({
  processId: CUSTOM_PROCESS_CONFIG.processId,
  ao: customAo,
});